import { styled } from "@mui/material/styles";
import { DataGridPremium } from "@mui/x-data-grid-premium";

const TABLE_BORDER_COLOR = "#EBEBF7";

export const StyledDataGridPremium = styled(DataGridPremium)(({ theme }) => ({
  backgroundColor: "#fff",
  borderColor: TABLE_BORDER_COLOR,
  height: "100%",
  "& .MuiDataGrid-withBorder": {
    borderColor: TABLE_BORDER_COLOR,
  },
  "& .MuiDataGrid-columnHeaders": {
    borderColor: TABLE_BORDER_COLOR,
    backgroundColor: "#FAFAFF",
  },

  "& .MuiDataGrid-sortIcon": {
    width: "1em",
    height: "1em",
  },

  "& .MuiDataGrid-columnHeaderTitleContainer .MuiIconButton-root": {
    marginLeft: theme.spacing(0.5),
  },
}));
